const ANTHROPIC_API_URL = 'https://api.anthropic.com/v1/messages';
const API_KEY = process.env.REACT_APP_ANTHROPIC_API_KEY;

export async function callClaude({ prompt, systemPrompt, maxTokens = 1024 }) {
  const response = await fetch(ANTHROPIC_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY,
      'anthropic-version': '2023-06-01',
      'anthropic-dangerous-direct-browser-access': 'true',
    },
    body: JSON.stringify({
      model: 'claude-haiku-4-5-20251001',
      max_tokens: maxTokens,
      system: systemPrompt,
      messages: [{ role: 'user', content: prompt }],
    }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.error?.message || `Anthropic API error ${response.status}`);
  }

  const data = await response.json();
  return data.content[0].text;
}

export async function callClaudeWithImage({ imageBase64, mediaType, prompt, systemPrompt, maxTokens = 2048 }) {
  const response = await fetch(ANTHROPIC_API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-api-key': API_KEY,
      'anthropic-version': '2023-06-01',
      'anthropic-dangerous-direct-browser-access': 'true',
    },
    body: JSON.stringify({
      model: 'claude-haiku-4-5-20251001',
      max_tokens: maxTokens,
      system: systemPrompt,
      messages: [{
        role: 'user',
        content: [
          { type: 'image', source: { type: 'base64', media_type: mediaType, data: imageBase64 } },
          { type: 'text', text: prompt },
        ],
      }],
    }),
  });

  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(err?.error?.message || `Anthropic API error ${response.status}`);
  }

  const data = await response.json();
  return data.content[0].text;
}

export async function parseReaderFromEmail(emailText) {
  const systemPrompt = `You are a data extraction assistant for an author's ARC (Advance Review Copy) reader management tool.
Extract reader information from pasted signup email content and return ONLY a valid JSON object — no explanation, no markdown fences.

Fields to extract (use empty string "" if not found, empty array [] for arrays):
- name: string
- emailCorrespondence: string (main email)
- eReaderEmail: string (kindle/kobo delivery email — use emailCorrespondence if not separately provided)
- acceptsMarketing: boolean (default true, false only if explicitly declined)
- interestedIn: string (e.g. "eBook ARC request")
- reviewPlatforms: array of strings (e.g. ["Instagram", "TikTok", "Amazon"])
- socialUsernames: string
- favoriteBooks: string
- location: string

Example output:
{"name":"Jane Doe","emailCorrespondence":"jane@gmail.com","eReaderEmail":"jane@kindle.com","acceptsMarketing":true,"interestedIn":"eBook ARC request","reviewPlatforms":["Instagram","Goodreads"],"socialUsernames":"@janereads","favoriteBooks":"The Night Circus","location":"London, UK"}`;

  const text = await callClaude({
    systemPrompt,
    prompt: emailText,
    maxTokens: 512,
  });

  try {
    return JSON.parse(text.trim());
  } catch {
    throw new Error('Claude returned unexpected format. Please try again.');
  }
}
